import { useParams } from 'react-router-dom';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AmendmentCreateEditComponent } from './amendment-create-edit-component';
import { AmendmentCreateEditProvider } from './context/amendment-create-edit-context';

export function AmendmentCreateEditFactory() {
    // A chave reinicia o estado ao trocar de termo pela rota
    const { contractId, sequentialId } = useParams();

    return (
        <BaseLayoutFactory>
            <AmendmentCreateEditProvider key={`${contractId}-${sequentialId ?? 'new'}`}>
                <AmendmentCreateEditComponent />
            </AmendmentCreateEditProvider>
        </BaseLayoutFactory>
    );
}
